(function () {
  'use strict';

  var config = window.VenucastSolutionFinderConfig;
  if (!config) return;

  document.querySelectorAll('[data-solution-finder]').forEach(initFinder);

  function initFinder(root) {
    var storageKey = 'venucast_find_my_setup_v1';
    var screens = ['venueType', 'audienceSize', 'listeningDevices'];
    var state = {
      screen: 'useCase',
      answers: {},
      recommendationId: '',
      attemptId: ''
    };
    var questionCard = root.querySelector('[data-finder-question-card]');
    var questionHost = root.querySelector('[data-finder-question]');
    var resultHost = root.querySelector('[data-finder-result]');
    var logEndpoint = normalizeEndpoint(root.getAttribute('data-log-endpoint'));
    var params = new URLSearchParams(window.location.search);
    var presetUseCase = normalizeUseCase(params.get('use_case'));
    var transitionRequested = false;

    restoreSession();

    if (presetUseCase) {
      state.answers = { useCase: presetUseCase };
      state.screen = 'venueType';
      state.recommendationId = '';
      state.attemptId = newAttemptId();
      saveSession();
    }

    root.querySelectorAll('[data-finder-help]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('solution_finder_cta_clicked', {
          cta_type: link.getAttribute('data-finder-help'),
          recommended_setup: state.recommendationId
        });
      });
    });

    window.addEventListener('beforeunload', function () {
      if (state.screen === 'useCase' || state.screen === 'result') return;
      track('solution_finder_abandoned', {
        stuck_at_question: state.screen,
        completed_answers: Object.keys(state.answers).join(',') || 'none'
      }, true);
    });

    questionHost.addEventListener('click', handleQuestionClick);

    render();

    function handleQuestionClick(event) {
      var useCaseButton = event.target.closest('[data-use-case]');
      if (useCaseButton) {
        state.answers = { useCase: useCaseButton.getAttribute('data-use-case') };
        state.screen = 'venueType';
        state.recommendationId = '';
        state.attemptId = newAttemptId();
        track('solution_finder_started', {
          start_source: 'use_case',
          use_case: state.answers.useCase,
          entry_page: window.location.pathname + window.location.search
        });
        recordAnswer('useCase', state.answers.useCase, 'venueType');
        saveSession();
        transitionRequested = true;
        render();
        return;
      }

      if (event.target.closest('[data-back-use-cases]')) {
        goToUseCases();
        return;
      }

      var index = screens.indexOf(state.screen);
      if (event.target.closest('[data-finder-back]')) {
        if (index <= 0) goToUseCases();
        else {
          state.screen = screens[index - 1];
          saveSession();
          transitionRequested = true;
          render();
        }
        return;
      }

      var answerButton = event.target.closest('[data-finder-answer]');
      if (answerButton && index !== -1) {
        var question = getQuestion(state.screen);
        var value = answerButton.getAttribute('data-finder-answer');
        if (question.multiple) updateMultipleAnswer(state.screen, value);
        else state.answers[state.screen] = value;
        clearFollowingAnswers(index);
        saveSession();
        renderQuestion(state.screen);
        return;
      }

    }

    function advanceFromQuestion(event) {
      event.preventDefault();
      event.stopPropagation();
      var index = screens.indexOf(state.screen);
      if (index === -1) return;
      var nextScreen = index === screens.length - 1 ? 'result' : screens[index + 1];
      recordAnswer(state.screen, state.answers[state.screen], nextScreen);
      state.screen = nextScreen;
      if (nextScreen === 'result') {
        var match = getRecommendation();
        state.recommendationId = match ? match.id : '';
      }
      saveSession();
      transitionRequested = true;
      render();
    }

    function render() {
      questionCard.hidden = state.screen === 'result';
      resultHost.hidden = state.screen !== 'result';

      if (state.screen === 'result') renderResult();
      else if (state.screen === 'useCase') renderUseCases();
      else renderQuestion(state.screen);

      if (transitionRequested) {
        transitionRequested = false;
        focusCurrentHeading();
        scrollToFinder();
      }
    }

    function renderUseCases() {
      var cards = config.useCases.map(function (useCase) {
        return '<button class="sf-use-case" type="button" data-use-case="' + escapeHtml(useCase.value) + '">' +
          '<span class="sf-use-case__icon" aria-hidden="true">' + iconSvg(useCase.icon) + '</span>' +
          '<span class="sf-use-case__copy"><strong>' + escapeHtml(useCase.label) + '</strong><span>' + escapeHtml(useCase.description) + '</span></span>' +
          '<span class="sf-use-case__arrow" aria-hidden="true">' + iconSvg('arrow') + '</span>' +
        '</button>';
      }).join('');

      questionHost.innerHTML =
        '<div class="sf-start">' +
          '<div class="sf-start__intro">' +
            '<span class="sf-eyebrow">Find Your Setup</span>' +
            '<h1 tabindex="-1">What do you need audio for?</h1>' +
            '<p class="sf-lead">Choose the option that best matches your situation. We’ll ask a few quick questions and recommend the right VenuCast setup.</p>' +
            '<div class="sf-reassurance" aria-label="Finder benefits">' +
              reassuranceItem('clock', '2–3 minutes', 'No technical knowledge needed') +
              reassuranceItem('settings', 'Tailored to your venue', 'Get a complete recommendation') +
              reassuranceItem('plug', 'Plug & Play', 'Easy to set up and use') +
            '</div>' +
            '<a class="sf-products-link" href="' + escapeHtml(root.getAttribute('data-products-url') || '/collections/view-all-products') + '">Already know what you need? Browse Products <span aria-hidden="true">→</span></a>' +
          '</div>' +
          '<div class="sf-use-cases" role="group" aria-label="Choose a use case">' + cards + '</div>' +
        '</div>';

    }

    function reassuranceItem(icon, title, copy) {
      return '<div class="sf-reassurance__item"><span aria-hidden="true">' + iconSvg(icon) + '</span><div><strong>' + title + '</strong><small>' + copy + '</small></div></div>';
    }

    function renderQuestion(key) {
      var question = getQuestion(key);
      var currentAnswer = state.answers[key];
      var isMultiple = Boolean(question.multiple);
      var options = question.options.map(function (option) {
        var selected = isMultiple
          ? Array.isArray(currentAnswer) && currentAnswer.indexOf(option.value) !== -1
          : currentAnswer === option.value;
        return '<button type="button" class="sf-option' + (selected ? ' is-selected' : '') + '" data-finder-answer="' + escapeHtml(option.value) + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
          '<span>' + escapeHtml(option.label) + '</span>' +
          '<span class="sf-option__check" aria-hidden="true">' + (selected ? iconSvg('check') : '') + '</span>' +
        '</button>';
      }).join('');
      var canContinue = isMultiple ? Array.isArray(currentAnswer) && currentAnswer.length > 0 : Boolean(currentAnswer);
      var index = screens.indexOf(key);
      var eyebrow = config.questions.venueType.eyebrowByUseCase[state.answers.useCase] || 'Find Your Setup';

      questionHost.innerHTML =
        '<button class="sf-back-to-use-cases" type="button" data-back-use-cases>← Back to use cases</button>' +
        renderProgress(index) +
        '<div class="sf-question__header">' +
          '<span class="sf-eyebrow">' + escapeHtml(eyebrow) + '</span>' +
          '<h1 tabindex="-1">' + escapeHtml(question.title) + '</h1>' +
          '<p>' + escapeHtml(question.helper) + '</p>' +
        '</div>' +
        (key === 'listeningDevices' ? '<p class="sf-multi-note">Choose more than one if your venue serves different listeners.</p>' : '') +
        '<div class="sf-options sf-options--' + key + '" role="group" aria-label="' + escapeHtml(question.title) + '">' + options + '</div>' +
        (key === 'venueType' ? '<p class="sf-info-note"><span aria-hidden="true">' + iconSvg('info') + '</span><span><strong>Don’t worry if it’s not an exact match.</strong> We’ll recommend the closest solution.</span></p>' : '') +
        '<div class="sf-question__actions">' +
          '<button class="sf-button sf-button--back" type="button" data-finder-back>← Back</button>' +
          (canContinue
            ? '<button class="sf-next-action" type="button" data-vnk-next>' + (key === 'listeningDevices' ? 'See My Recommendation' : 'Next') + ' <span aria-hidden="true">→</span></button>'
            : '<button class="sf-next-action" type="button" disabled>' + (key === 'listeningDevices' ? 'See My Recommendation' : 'Next') + ' <span aria-hidden="true">→</span></button>') +
        '</div>';

      var nextControl = questionHost.querySelector('[data-vnk-next]');
      if (nextControl) {
        var boundScreen = state.screen;
        var advanceOnce = function (event) {
          if (state.screen !== boundScreen) return;
          advanceFromQuestion(event);
        };
        nextControl.addEventListener('pointerdown', advanceOnce, true);
        nextControl.addEventListener('click', advanceOnce, true);
        nextControl.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') advanceOnce(event);
        }, true);
      }

    }

    function renderProgress(activeIndex) {
      var labels = ['Venue Type', 'Audience Size', 'Listening Devices', 'Your Recommendation'];
      return '<ol class="sf-progress" aria-label="Recommendation progress">' + labels.map(function (label, index) {
        var status = index < activeIndex ? ' is-complete' : index === activeIndex ? ' is-active' : '';
        return '<li class="sf-progress__step' + status + '"' + (index === activeIndex ? ' aria-current="step"' : '') + '><span>' + (index + 1) + '</span><strong>' + label + '</strong></li>';
      }).join('') + '</ol>';
    }

    function getQuestion(key) {
      if (key === 'venueType') {
        var venue = config.questions.venueType;
        return {
          title: venue.title,
          helper: venue.helper,
          options: venue.optionsByUseCase[state.answers.useCase] || venue.optionsByUseCase.not_sure
        };
      }
      if (key === 'audienceSize') {
        var audience = config.questions.audienceSize;
        var override = audience.overrides[state.answers.useCase];
        return override || audience;
      }
      return config.questions.listeningDevices;
    }

    function updateMultipleAnswer(key, value) {
      var selected = Array.isArray(state.answers[key]) ? state.answers[key].slice() : [];
      var exclusive = value === 'mixed' || value === 'not_sure';
      if (exclusive) {
        selected = selected.length === 1 && selected[0] === value ? [] : [value];
      } else {
        selected = selected.filter(function (item) { return item !== 'mixed' && item !== 'not_sure'; });
        var existing = selected.indexOf(value);
        if (existing === -1) selected.push(value);
        else selected.splice(existing, 1);
      }
      state.answers[key] = selected;
    }

    function clearFollowingAnswers(index) {
      screens.slice(index + 1).forEach(function (key) { delete state.answers[key]; });
      state.recommendationId = '';
    }

    function renderResult() {
      var match = getRecommendation();
      if (!match || !config.systems[match.system]) {
        state.screen = 'useCase';
        state.answers = {};
        state.recommendationId = '';
        saveSession();
        render();
        return;
      }

      var system = config.systems[match.system];
      var addOns = getAddOns();
      state.recommendationId = match.id;
      questionCard.hidden = true;
      resultHost.hidden = false;
      resultHost.innerHTML =
        '<div class="sf-result__top">' +
          '<button class="sf-back-to-use-cases" type="button" data-result-back>← Back to answers</button>' +
          '<button class="sf-restart" type="button" data-restart>Start Over</button>' +
        '</div>' +
        renderResultProgress() +
        '<header class="sf-result__header">' +
          '<span class="sf-eyebrow">Your Recommended Setup</span>' +
          '<h1 tabindex="-1">' + escapeHtml(buildResultSummary()) + '</h1>' +
        '</header>' +
        '<article class="sf-system">' +
          '<div class="sf-system__media">' + (system.image
            ? '<img src="' + escapeHtml(system.image) + '" alt="' + escapeHtml(system.title) + '" width="520" height="390">'
            : '<span aria-hidden="true">' + iconSvg('counter') + '</span>') + '</div>' +
          '<div class="sf-system__content">' +
            '<span class="sf-system__label">Recommended System</span>' +
            '<h2>' + escapeHtml(system.title) + '</h2>' +
            '<p class="sf-system__subtitle">' + escapeHtml(system.subtitle) + '</p>' +
            '<strong class="sf-good-for__title">Good for:</strong>' +
            '<ul class="sf-good-for">' + system.goodFor.map(function (item) { return '<li>' + iconSvg('check') + '<span>' + escapeHtml(item) + '</span></li>'; }).join('') + '</ul>' +
            '<div class="sf-system__actions">' +
              '<a class="sf-button sf-button--primary" href="' + escapeHtml(system.url) + '" data-result-cta="view_setup">View This Setup <span aria-hidden="true">→</span></a>' +
              '<a class="sf-button sf-button--secondary" href="' + escapeHtml(advisorUrl()) + '" data-result-cta="ask_us">Need Help? Ask Us <span aria-hidden="true">→</span></a>' +
            '</div>' +
          '</div>' +
        '</article>' +
        (addOns.length ? '<section class="sf-addons" aria-labelledby="sf-addons-title-' + escapeHtml(root.getAttribute('data-section-id') || 'finder') + '"><div class="sf-addons__header"><span class="sf-eyebrow">Optional Compatibility</span><h2 id="sf-addons-title-' + escapeHtml(root.getAttribute('data-section-id') || 'finder') + '">Listening options for your users</h2></div><div class="sf-addons__grid">' + addOns.map(renderAddOn).join('') + '</div></section>' : '') +
        '<aside class="sf-compliance"><div><span class="sf-compliance__icon" aria-hidden="true">' + iconSvg('accessibility') + '</span><div><strong>Need to meet accessibility requirements?</strong><p>Use venue capacity and location to estimate a planning quantity, then confirm local requirements.</p></div></div><a href="' + escapeHtml(root.getAttribute('data-compliance-url') || '/pages/1-min-venue-setup-planner') + '" data-result-cta="check_requirements">Check Requirements <span aria-hidden="true">→</span></a></aside>';

      resultHost.querySelector('[data-result-back]').addEventListener('click', function () {
        state.screen = 'listeningDevices';
        saveSession();
        transitionRequested = true;
        render();
      });
      resultHost.querySelector('[data-restart]').addEventListener('click', restart);
      resultHost.querySelectorAll('[data-result-cta]').forEach(function (link) {
        link.addEventListener('click', function () {
          track('solution_finder_cta_clicked', {
            cta_type: link.getAttribute('data-result-cta'),
            recommended_setup: match.id,
            system: match.system
          });
        });
      });

      saveSession();
      track('solution_finder_recommendation', {
        recommended_setup: match.id,
        system: match.system,
        use_case: state.answers.useCase,
        venue_type: state.answers.venueType,
        audience_size: state.answers.audienceSize,
        listening_devices: state.answers.listeningDevices.join(',')
      });
    }

    function renderResultProgress() {
      var labels = ['Venue Type', 'Audience Size', 'Listening Devices', 'Your Recommendation'];
      return '<ol class="sf-progress" aria-label="Recommendation progress">' + labels.map(function (label, index) {
        return '<li class="sf-progress__step ' + (index === 3 ? 'is-active' : 'is-complete') + '"' + (index === 3 ? ' aria-current="step"' : '') + '><span>' + (index + 1) + '</span><strong>' + label + '</strong></li>';
      }).join('') + '</ol>';
    }

    function getRecommendation() {
      return config.recommendations.find(function (rule) {
        return Object.keys(rule.when).every(function (key) {
          return rule.when[key].indexOf(state.answers[key]) !== -1;
        });
      }) || null;
    }

    function getAddOns() {
      var selected = Array.isArray(state.answers.listeningDevices) ? state.answers.listeningDevices : [];
      if (selected.indexOf('mixed') !== -1 || selected.indexOf('not_sure') !== -1) {
        selected = ['auracast', 'tcoil', 'bluetooth', 'venue_receivers'];
      }
      return selected.map(function (key) { return config.addOns[key]; }).filter(Boolean);
    }

    function renderAddOn(addOn) {
      return '<article class="sf-addon"><div><strong>' + escapeHtml(addOn.title) + '</strong><a href="' + escapeHtml(addOn.url) + '" data-result-cta="compatibility_addon">' + escapeHtml(addOn.product) + ' <span aria-hidden="true">→</span></a></div><p>' + escapeHtml(addOn.description) + '</p></article>';
    }

    function buildResultSummary() {
      var venue = findLabel(getQuestion('venueType').options, state.answers.venueType);
      var audience = findLabel(getQuestion('audienceSize').options, state.answers.audienceSize);
      var devices = state.answers.listeningDevices || [];
      var listening = devices.indexOf('mixed') !== -1 || devices.length > 1 ? 'mixed listening needs' : devices.indexOf('not_sure') !== -1 ? 'listening needs to confirm' : 'the selected listening devices';
      if (state.answers.useCase === 'service_counter') return 'For ' + (venue || 'a service counter') + ' with ' + (audience || 'a counter count to confirm');
      return 'For a ' + (audience || 'size to confirm') + ' person ' + (venue || 'venue') + ' with ' + listening;
    }

    function advisorUrl() {
      var base = root.getAttribute('data-question-url') || '/pages/contact-us';
      var summary = [
        'Use case: ' + findLabel(config.useCases, state.answers.useCase),
        'Venue: ' + findLabel(getQuestion('venueType').options, state.answers.venueType),
        'Audience: ' + findLabel(getQuestion('audienceSize').options, state.answers.audienceSize),
        'Listening devices: ' + (state.answers.listeningDevices || []).map(function (value) { return findLabel(config.questions.listeningDevices.options, value); }).filter(Boolean).join(', '),
        'Recommended setup: ' + state.recommendationId
      ].join('\n');
      return base + (base.indexOf('?') === -1 ? '?' : '&') + 'source=solution_finder&finder_summary=' + encodeURIComponent(summary);
    }

    function goToUseCases() {
      state.screen = 'useCase';
      state.answers = {};
      state.recommendationId = '';
      saveSession();
      transitionRequested = true;
      render();
    }

    function restart() {
      track('solution_finder_restarted', { previous_result: state.recommendationId });
      state.screen = 'useCase';
      state.answers = {};
      state.recommendationId = '';
      state.attemptId = '';
      saveSession();
      transitionRequested = true;
      render();
    }

    function recordAnswer(question, answer, nextQuestion) {
      track('solution_finder_answered', {
        question: question,
        answer: Array.isArray(answer) ? answer.join(',') : answer,
        next_question: nextQuestion,
        use_case: state.answers.useCase
      });
    }

    function findLabel(options, value) {
      var option = (options || []).find(function (item) { return item.value === value; });
      return option ? option.label : '';
    }

    function normalizeUseCase(value) {
      if (!value) return '';
      var normalized = value.toLowerCase().trim().replace(/[\s-]+/g, '_');
      var aliases = {
        assistive: 'assistive_listening',
        church: 'assistive_listening',
        theater: 'assistive_listening',
        classroom: 'assistive_listening',
        meeting: 'assistive_listening',
        senior_living: 'assistive_listening',
        guided_tour: 'tours_training',
        tour: 'tours_training',
        silent_event: 'silent_events',
        multi_room: 'overflow_remote',
        church_overflow: 'overflow_remote',
        distributed_audio: 'overflow_remote'
      };
      normalized = aliases[normalized] || normalized;
      return config.useCases.some(function (item) { return item.value === normalized; }) ? normalized : '';
    }

    function normalizeEndpoint(value) {
      return value && /^https:\/\//i.test(value) ? value : '';
    }

    function saveSession() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          version: config.version,
          screen: state.screen,
          answers: state.answers,
          recommendationId: state.recommendationId,
          attemptId: state.attemptId
        }));
      } catch (error) {}
    }

    function restoreSession() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (!saved || saved.version !== config.version) return;
        state.screen = ['useCase', 'venueType', 'audienceSize', 'listeningDevices', 'result'].indexOf(saved.screen) !== -1 ? saved.screen : 'useCase';
        state.answers = saved.answers || {};
        state.recommendationId = saved.recommendationId || '';
        state.attemptId = saved.attemptId || '';
      } catch (error) {}
    }

    function track(eventName, properties, useBeacon) {
      var payload = Object.assign({
        event_id: newUuid(),
        event: eventName,
        finder_version: config.version,
        attempt_id: state.attemptId || '',
        event_time: new Date().toISOString(),
        page_path: window.location.pathname,
        current_question: state.screen
      }, properties || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        try { window.Shopify.analytics.publish(eventName, payload); } catch (error) {}
      }
      sendToLogEndpoint(payload, Boolean(useBeacon));
      document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    }

    function sendToLogEndpoint(payload, useBeacon) {
      if (!logEndpoint) return;
      var body = JSON.stringify(payload);
      if (useBeacon && navigator.sendBeacon) {
        navigator.sendBeacon(logEndpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        return;
      }
      fetch(logEndpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body,
        keepalive: true
      }).catch(function () {});
    }

    function newAttemptId() {
      return newUuid();
    }

    function newUuid() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
        var random = Math.floor(Math.random() * 16);
        var value = character === 'x' ? random : (random & 3) | 8;
        return value.toString(16);
      });
    }

    function focusCurrentHeading() {
      var heading = root.querySelector('[data-finder-question-card]:not([hidden]) h1, [data-finder-result]:not([hidden]) h1');
      if (heading) heading.focus({ preventScroll: true });
    }

    function scrollToFinder() {
      window.requestAnimationFrame(function () {
        root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character];
      });
    }

    function iconSvg(name) {
      var icons = {
        assistive: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8.5a5 5 0 0 0-10 0c0 3.2 2.2 4.4 3.1 6.3.5 1.1.4 2.7 1.9 3.2 1.7.5 3-1 3-2.5"/><path d="M10 9a2 2 0 1 1 3.3 1.5c-.9.7-1.3 1.3-1.3 2.5"/></svg>',
        tour: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 20v-8a7 7 0 0 1 14 0v8"/><path d="M5 15H3v-3h2m14 3h2v-3h-2"/><path d="M9 20h6"/></svg>',
        silent: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14h3l4 4V6L7 10H4z"/><path d="m16 9 5 5m0-5-5 5"/></svg>',
        rooms: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="7" height="14" rx="1"/><rect x="14" y="5" width="7" height="14" rx="1"/><path d="M10 12h4m-6 3h.01m8 0h.01"/></svg>',
        counter: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11h18v3H3zM5 14v6m14-6v6"/><circle cx="8" cy="6" r="2"/><path d="M12 8c1.5-2 3.5-2 5 0"/></svg>',
        help: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.7 9a2.4 2.4 0 1 1 3.6 2.1c-.9.5-1.3 1-1.3 1.9m0 3h.01"/></svg>',
        clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
        settings: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h10m4 0h2M4 17h4m4 0h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></svg>',
        plug: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M8 4v5m8-5v5M6 9h12v2a6 6 0 0 1-12 0zM12 17v3"/></svg>',
        arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
        check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4 4L19 6"/></svg>',
        info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5m0-8h.01"/></svg>',
        accessibility: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="4" r="2"/><path d="M5 8h14m-7 0v5m0 0-4 7m4-7 4 7"/></svg>'
      };
      return icons[name] || '';
    }
  }
})();
